import {
  CreateParams,
  CreateResult,
  DeleteParams,
  DeleteResult,
  GetListParams,
  GetListResult,
  GetOneParams,
  GetOneResult,
  RaRecord,
  UpdateParams,
  UpdateResult,
} from "react-admin";
import { deleteJson, getJson, postJson, putJson } from "../../../utils/api";
import IHandler from "./IHandler";

export default class CurriculumHandler implements IHandler {
  static route = "/admin";

  /* eslint-disable @typescript-eslint/no-unused-vars */
  static async getListHandler<RecordType extends RaRecord = any>(
    _resource?: string,
    _params?: GetListParams
  ): Promise<GetListResult<RecordType>> {
    /* eslint-enable @typescript-eslint/no-unused-vars */
    return getJson(`${CurriculumHandler.route}/curricula`).then(
      async (response) => {
        const { data: responseData } = await response.json();
        return {
          data: responseData ?? [],
          total: responseData?.length ?? 0,
        };
      }
    );
  }

  static async getOneHandler<RecordType extends RaRecord = any>(
    _resource?: string,
    params?: GetOneParams<any>
  ): Promise<GetOneResult<RecordType>> {
    const id = params?.id;
    return getJson(`${CurriculumHandler.route}/curricula`).then(
      async (response) => {
        const { data: items } = await response.json();
        const item = items.find((c: any) => c.id === id);
        return { data: item };
      }
    );
  }

  static async createHandler<RecordType extends RaRecord = any>(
    _resource?: string,
    params?: CreateParams<any>
  ): Promise<CreateResult<RecordType>> {
    const payload = params?.data;
    return postJson(`${CurriculumHandler.route}/curricula`, payload).then(
      async (response) => {
        const { data } = await response.json();
        return { data };
      }
    );
  }

  static async updateHandler<RecordType extends RaRecord = any>(
    _resource?: string,
    params?: UpdateParams<any>
  ): Promise<UpdateResult<RecordType>> {
    const id = params?.id;
    const payload = params?.data;
    return putJson(`${CurriculumHandler.route}/curricula/${id}`, payload).then(
      async (response) => {
        const { data } = await response.json();
        return { data };
      }
    );
  }

  static async deleteHandler<RecordType extends RaRecord = any>(
    _resource?: string,
    params?: DeleteParams<any>
  ): Promise<DeleteResult<RecordType>> {
    const id = params?.id;
    return deleteJson(`${CurriculumHandler.route}/curricula/${id}`).then(
      async (response) => {
        const { data } = await response.json();
        return { data: { ...data, id } as any };
      }
    );
  }
}
